import { FC } from 'react';
import { Level01State } from './level01.state';
import styles from './level01.module.scss';
import Breadcrumbs from '@components/shared/miscellaneous/breadcrumbs/breadcrumbs';
import PreviewSection from '@components/projects/level01/sections/preview/preview';
import SpecialProductSection from '@components/projects/level01/sections/special-product/special-product';
import CollaborationsSection from '@components/projects/level01/sections/collaborations/collaborations';
import ProjectInfoSection from '@components/projects/level01/sections/project-info/project-info';
import FAQSection from '@components/projects/level01/sections/faq/faq';
import TechnologyStackSection from '@components/projects/level01/sections/technology-stack/technology-stack';
import KeyFeaturesSection from '@components/projects/level01/sections/key-features/key-features';
import OurResultsSection from '@components/projects/level01/sections/our-results/our-results';
import Level01Animation from '@components/projects/level01/animations';

interface Level01ProjectProps {
  breadcrumbsText: string;
}

const Level01Component: FC<Level01ProjectProps> = ({ breadcrumbsText }) => {
  const {
    preview,
    specialProduct,
    collaboration,
    projectInfo,
    developmentChallenges,
    technologyStack,
    keyFeatures,
    ourResults,
  } = Level01State;

  return (
    <>
      <Breadcrumbs lastElementTitle={breadcrumbsText} />
      <PreviewSection section={preview} />
      <SpecialProductSection section={specialProduct} />
      <CollaborationsSection section={collaboration} />
      <ProjectInfoSection section={projectInfo} />
      <FAQSection section={developmentChallenges} />
      <TechnologyStackSection section={technologyStack} />
      <KeyFeaturesSection section={keyFeatures} />
      <OurResultsSection section={ourResults} />
    </>
  );
};

export default Level01Component;
